<div
    class="relative"
    [ngClass]="{
        'w-input_standard': inputSize === 'standard',
        'w-input_small': inputSize === 'small'
    }">
    @if (hasPrefixIcon) {
    <span class="absolute inset-y-0 left-0 px-xs flex items-center">
        <ng-content select="[apxPrefix]"></ng-content>
    </span>
    }
    <ng-content select="[apxInput]"></ng-content>
    @if (hasSuffixIcon) {
    <span class="absolute inset-y-0 right-0 px-xs flex items-center">
        <ng-content select="[apxSuffix]"></ng-content>
    </span>
    }
</div>
